import { useParams } from "react-router-dom";

const Public = () => {
	const { id } = useParams();

	return <div>Public: {id}</div>;
};

export default Public;
